//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const countries = require('~/data/countries.json')
const phone_codes = require('~/data/phone_codes.json')
export default {
  data() {
    return {
      current_step: 0,
      nationality: null,
      user_country: null,
      document_type: null,
      // document_exp: null,
      document_number: '',
      first_name: '',
      last_name: '',
      last_name2: '',
      gender: null,
      birth_date: null,
      email: '',
      phone_country_code: null,
      telephone: '',
      address: '',
      city: null,
      other_city: '',
      zipcode: '',
      tax_region: '',
      province: '',
      terms_accepted: null,
      accept_all: false,
      accept_sms: false,
      accept_email: false,
      accept_call: false,
      accept_popups: false,
      affiliation_bonus_code: this.$route.query['bonuscode'] ?? '',

      username: '',
      password: '',
      password_confirmation: '',
      showPassword: false,
      form_1_check: null,
      form_2_check: null,

      submitting: false,
      error: "",
      registration_success_message: '',
      countries,
      phone_codes,
      cities: [],
      tax_regions: [],
      errors: [],
      showOtherCityInput: false,
      registrationAttemptEventPushed: false
    }
  },
  methods: {
    beforeOpen (event) {
      this.error = ""
      window.dispatchEvent(new Event('resize'));
    },
    close() {
       this.$modal.hide('modal-registration')
    },
    closed() {
      if(this.current_step == 2) {
        this.resetForm()
      }
    },
    resetForm() {
      this.current_step = 0
      this.nationality = null
      this.user_country = null
      this.document_type = null
      // this.document_exp = null
      this.document_number = ''
      this.first_name = ''
      this.last_name = ''
      this.last_name2 = ''
      this.gender = null
      this.birth_date = null
      this.email = ''
      this.phone_country_code = null
      this.telephone = null
      this.address = ''
      this.city = null
      this.other_city = ''
      this.zipcode = ''
      this.tax_region = ''
      this.tax_regions = []
      this.province = ''
      this.terms_accepted = null
      this.accept_all = false
      this.accept_sms = false
      this.accept_email = false
      this.accept_call = false
      this.accept_popups = false
      this.affiliation_bonus_code = this.$route.query['bonuscode'] ?? ''

      this.username = ''
      this.password = ''
      this.password_confirmation = ''
      this.showPassword = false
      this.form_1_check = null
      this.form_2_check = null

      this.submitting = false
      this.error = ""
      this.registration_success_message = ''
      this.showOtherCityInput = false
    },
    getFormData() {
      const ES_BONUS_CODE_REGEX = /^[0-9a-zA-Z_. ]+$/u;
      
      return {
          nationality: this.nationality,
          country: this.user_country,
          document_type: this.document_type,
          document_number: this.document_number,
          // document_type2: NIE,
          // document_number2: X1699328L,
          first_name: this.first_name,
          last_name: this.last_name,
          last_name2: this.last_name2,
          gender: +this.gender,
          birth_date: this.birth_date,
          email: this.email,
          phone: this.telephone,
          phone_country_code: _.get(_.find(phone_codes, {country: this.phone_country_code}), 'code'),
          zipcode: this.zipcode,
          province: this.province,
          city: this.city? this.city: this.other_city,
          address: this.address,
          tax_region: this.tax_region,
          affiliation_bonus_code: ES_BONUS_CODE_REGEX.test(this.affiliation_bonus_code) ? this.affiliation_bonus_code : '',
          terms_accepted: +this.terms_accepted,
          mkt_emails_accepted: +this.accept_email,
          mkt_sms_accepted: +this.accept_sms,
          mkt_phone_calls_accepted: +this.accept_call,
          mkt_popups_accepted: +this.accept_popups,
          username: this.username,
          password: this.password,
          password_confirm: this.password_confirmation
        }
    },
    async submit() {
      let result = null
      this.error = ""
      this.submitting = true
      try {
        let response = await this.$auth().post('/api/common/register', this.getFormData())
        let data = _.get(response, 'data')

        const hooyu_check = response?.data?.hooyu

        if( _.get(data, 'result') ) {

          if(_.get(data, 'verify_message')) {
            this.registration_success_message = _.get(data, 'verify_message')
          } else {
            this.registration_success_message = this.$t('Registration success')
          }
          this.$gtm.push(data.aff);
          this.$notyf.success(this.$t('Registration success'))
          const hooyu_check_status = hooyu_check?.status ?? false
          if (hooyu_check_status) {
            this.$notyf.success(this.$t('Registration success'))
          } else {
            this.$notyf.success(this.$t('Your account has been created and requires additional verification. Please log in and begin your document verification process.'))
          }
          result = true
        } else {
          if(_.isObject(_.get(data, 'errors'))) {
            this.error = _.get(_.values(_.get(data, 'errors')), '0')
            this.errors = _.get(data, 'errors')
          } else {
            this.error = _.get(data, 'errors')
          }
          result = false

          if (!this.registrationAttemptEventPushed) {
            this.registrationAttemptEventPushed = true;
            this.$gtm.push(data.aff);
          }
          let gtmDataLayerErrors = this.getGtmDataLayerErrors()
          if (gtmDataLayerErrors.length > 0) {
            this.$gtm.push({
              event: "registration_fail",
              reason: gtmDataLayerErrors.join('--'),
              product: data.aff.user.product,
              device: data.aff.user.device,
              idaffiliation: data.aff.user.affiliate_id
            })
          }
        }
      } catch(e) {
        console.error('response', data)
        result = false
        let data = _.get(e, 'response.data')
        if(_.isArray(_.get(data, 'message'))) {
            this.error = _.get(data, 'message.0')
        } else {
          this.error = _.get(data, 'message')
        }
        if(_.isObject(_.get(data, 'errors'))) {
          this.error = _.get(_.values(_.get(data, 'errors')), '0')
          this.errors = _.get(data, 'errors')
        } else {
          this.error = _.get(data, 'errors')
        }

        if (!this.registrationAttemptEventPushed) {
          this.registrationAttemptEventPushed = true;
          this.$gtm.push(data.aff);
        }
        let gtmDataLayerErrors = this.getGtmDataLayerErrors()
        if (gtmDataLayerErrors.length > 0) {
          this.$gtm.push({
            event: "registration_fail",
            reason: gtmDataLayerErrors.join('--'),
            product: data.aff.user.product,
            device: data.aff.user.device,
            idaffiliation: data.aff.user.affiliate_id
          })
        }
      }
      this.submitting = false

      return result
    },
    async nextStep() {
      if(this.current_step == 0 && !await this.validate_form_1()) {
        return
      }
      if(this.current_step == 1) {
        if(!await this.submit()) {
          return
        } 
        // else {
        //   let result = await this.submit()
        //   this.current_step++
        //   if(result == false) return
        // }
      }
      // this.errors = []
      this.current_step++
    },
    previousStep() {
      this.current_step--
    },
    togglePassword() {
      this.showPassword = !this.showPassword

      if(this.showPassword) {
        this.$refs.passwordInput.type = 'text'
        this.$refs.passwordConfirmInput.type = 'text'
      } else {
        this.$refs.passwordInput.type = 'password'
        this.$refs.passwordConfirmInput.type = 'password'
      }
    },
    setAcceptAll() {
      if(
        this.$refs.accept_call.checked && 
        this.$refs.accept_email.checked && 
        this.$refs.accept_call.checked && 
        this.$refs.accept_popups.checked && 
        this.$refs.accept_sms.checked
      ) {
        this.accept_all = true
      } else {
        this.accept_all = false
      }
    },
    acceptAll() {
      let checked = this.$refs.accept_all.checked
      this.accept_sms = checked
      this.accept_email = checked
      this.accept_call = checked
      this.accept_popups = checked
    },
    userCountryChanged() {
      this.phone_country_code = this.user_country
    },
    async zipcodeChanged() {
      try {
        this.submitting = true
        let response = await this.$auth().post('/api/common/get-zipcode-location', {zip_code: this.zipcode})
        let data = _.get(response, 'data')
        console.log('response', data)
        
        if( _.get(data, 'result') ) {
          this.errors['zipcode'] = ''

          if(_.get(data, 'zipcode.is_identified')) {
            this.province = _.get(data, 'zipcode.province')
  
            if(_.isArray(_.get(data, 'zipcode.tax_region'))) {
              this.tax_regions = _.get(data, 'zipcode.tax_region')
              this.tax_region = _.get(data, 'zipcode.tax_region.0.value')
            } else {
              this.tax_regions = [_.get(data, 'zipcode.tax_region')]
              this.tax_region = _.get(data, 'zipcode.tax_region.value')
            }
  
            // this.cities = [{value: '', text: ''}, {value: '', text: this.$t('Other')}]
            this.cities = [{value: '', text: this.$t('Other')}]
            _.each(_.get(data, 'zipcode.cities'), city => { this.cities.push({value: city, text: city}) })
            this.city = _.get(data, 'zipcode.cities.0')
            this.cityChanged()
          } else {
            this.cities = [{value: '', text: this.$t('Other')}]
            this.city = ''
            this.cityChanged()
          }
        } else {
           if(_.isArray(_.get(data, 'message'))) {
            this.errors['zipcode'] = _.get(data, 'message.0')
          } else {
            this.errors['zipcode'] = _.get(data, 'message')
          }
        }
      } catch(e) {
        this.errors['zipcode'] = ''
        console.log('error', e)
        let data = _.get(e, 'response.data')
        console.log('response', data)
        if(_.isArray(_.get(data, 'message'))) {
            this.error = _.get(data, 'message.0')
          } else {
            this.error = _.get(data, 'message')
          }
      }
      this.submitting = false
    },
    cityChanged() {
      if(this.city == '') {
        this.showOtherCityInput = true
      } else {
        this.showOtherCityInput = false
      }
    },
    getGtmDataLayerErrors() {
        let dataLayerErrors = []
        for (const key in this.errors) {
            if (key !== 'active_step') {
                dataLayerErrors.push(key + ':' + this.errors[key]);
            }
        }
        if (this.error) {
          dataLayerErrors.push(this.error);
        }
        return dataLayerErrors
    }, 
    async validate_form_1() {
      this.error = ""
      this.submitting = true
      let result = false

      try {
        let formData = _.omit(this.getFormData(), ['username', 'password', 'password_confirm'])
        let response = await this.$auth().post('/api/common/register', formData)
        let data = _.get(response, 'data')
        console.log('response', data)
        this.submitting = false
        
        if( _.get(data, 'result') ) {
          result = true
        } else {
          if(_.isObject(_.get(data, 'errors'))) {
            this.errors = _.get(data, 'errors')
            result = false

            if(_.size(_.get(data, 'errors')) == 3 && _.has(data, 'errors.username') && _.has(data, 'errors.password') && _.has(data, 'errors.password_confirm')) {
              this.errors = []
              result = true
            }
          } else {
            this.error = _.get(data, 'errors')
            result = false
          }

          if (!this.registrationAttemptEventPushed) {
            this.registrationAttemptEventPushed = true;
            this.$gtm.push(data.aff);
          }
          let gtmDataLayerErrors = this.getGtmDataLayerErrors()
          if (gtmDataLayerErrors.length > 0) {
            this.$gtm.push({
              event: "registration_fail",
              reason: gtmDataLayerErrors.join('--'),
              product: data.aff.user.product,
              device: data.aff.user.device,
              idaffiliation: data.aff.user.affiliate_id
            })
          }
        }              

      } catch(e) {
        console.error('error', e)
        let data = _.get(e, 'response.data')

        if(_.isArray(_.get(data, 'message'))) {
          this.error = _.get(data, 'message.0')
        } else {
          this.error = _.get(data, 'message')
        }
        this.$gtm.push({
          event: "registration_fail",
          reason: "Server error: " + this.error,
        })
        result = false
      }

      return result
      // if(!this.nationality ||
      //   !this.user_country ||
      //   !this.document_type ||
      //   !this.isValidDocumentNumber() ||
      //   // !this.document_exp ||
      //   !this.isValidFirstName() ||
      //   !this.isValidLastName() ||
      //   !this.isValidLastName2() ||
      //   !this.gender ||
      //   !this.birth_date ||
      //   !this.isValidEmail() ||
      //   !this.phone_country_code ||
      //   !this.isValidPhoneNumber() ||
      //   !this.address ||
      //   !this.isValidCity() ||
      //   !this.zipcode ||
      //   !this.tax_region ||
      //   !this.province ||
      //   !this.terms_accepted
      // ) {
      //     this.form_1_check = false
      //     return false
      //   }
    },
    async validate_form_2() {
      this.error = ""
      this.submitting = true
      let result = false

      try {
        let response = await this.$auth().post('/api/common/register', this.getFormData())
        let data = _.get(response, 'data')
        this.submitting = false
        console.log('response', data)
        
        if(_.get(data, 'result')) {
          result = true
        } else {
          if(_.isObject(_.get(data, 'errors'))) {
            this.errors = _.get(data, 'errors')
            result = false
          } else {
            this.error = _.get(data, 'errors')
            result = false
          }
        }
      } catch(e) {
        console.error('error', e)
        let data = _.get(e, 'response.data')

        if(_.isArray(_.get(data, 'message'))) {
          this.error = _.get(data, 'message.0')
        } else {
          this.error = _.get(data, 'message')
        }

        result = false
      }

      return result
      // if(
      //   !this.isValidUsername() ||
      //   !this.isValidPassword() ||
      //   !this.isValidPasswordConfirmation() ||
      //   // !this.isValidUsername()
      // ) {
      //   this.form_2_check = false
      //   return false
      // }
      // return true
    },
    nationalityChanged(e) {
      if(this.nationality == 'ES') {
        this.document_type = 'DNI'
        this.$refs.documentType.disabled = true
      } else if(this.nationality){
        this.document_type = 'NIE'
        this.$refs.documentType.disabled = true
      } else {
        this.$refs.documentType.disabled = false
      }
    },
    isValidUsername() {
      return !/[\`\~\!\@\$\#\%\^\&\*\(\)\{\}\[\]\:\;\'\|\\\,\.\<\>\?\/\"ñ ]/.test(this.username)
    },
    isValidEmail() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)
    },
    isValidPassword() {
      return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,20}$/.test(this.password)
    },
    isValidPasswordConfirmation() {
      return this.password === this.password_confirmation
    },
    isValidDocumentNumber() {
      const VALID_CHARS = 'TRWAGMYFPDXBNJZSQVHLCKE'

      if(this.document_type == 'DNI') {
        // convert to uppercase
        let DNI = this.document_number.trim().toUpperCase()
        // compatibility with old formats
        if (DNI.length < 9) {
          DNI = DNI.padStart(9, "0")
        }
        // get the essence from the number
        let letter = DNI.substr(-1)
        let number = parseInt(DNI)

        if(!/^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]{1}$/i.test(DNI)) {
          return false
        }
        // validate checksum
        if(VALID_CHARS.indexOf(letter) !== number % 23) {
            return false
        }
        return true
      }

      if(this.document_type == 'NIE') {
        // convert to uppercase
        let NIE = this.document_number.trim().toUpperCase()
        // get the essence from the number
        let letter = NIE.substr(-1);

        if(!/^[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]{1}$/i.test(NIE)) {
          //test for old NIE
          if(!/^[X]{1}[0]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]{1}$/i.test(NIE)) {
            console.log('validate doc invalid regex', NIE)
            return false
          }
          NIE = this.document_number.replace(/^[X0]/, 'X');
          console.log('validate doc old nie', NIE)
        }

        let nietest = NIE
        nietest = nietest.replace(/^[X]/, '0')
        nietest = nietest.replace(/^[Y]/, '1')
        nietest = nietest.replace(/^[Z]/, '2')
        let number = parseInt(nietest)

        // validate checksum
        if(VALID_CHARS.indexOf(letter) !== number % 23) {
          console.log('validate doc checksum', nietest)
          return false
        }
        return true
      }
    },
    isValidFirstName() {
      if(_.size(this.first_name) < 2 || _.size(this.first_name.length) > 40) {
        return false
      }
      return true
    },
    isValidLastName() {
      if(_.size(this.last_name) < 2 || _.size(this.last_name) > 40) {
        return false
      }
      return true
    },
    isValidLastName2() {
      if(this.document_type == 'DNI' && (_.size(this.last_name2) < 2 || _.size(this.last_name2) > 40)) {
        return false
      }
      return true
    },
    isValidPhoneNumber() {
      return /^[0-9]{9}$/i.test(this.telephone)
    },
    isValidZipcode() {},
    isValidCity() {
      if(_.size(this.city) < 2 || _.size(this.city) >40) {
        return false
      }
      return true
    },
  }
}
